import { ContentType } from "../api";
import i18n from "../locales/i18n";
import format from "xml-formatter";

export const formatLocalizedDateTime = (date: string | Date) => {
  const currentLanguage = i18n.language;
  if (currentLanguage === "de") {
    return new Date(date).toLocaleString("de-DE");
  } else {
    return new Date(date).toLocaleString("en-US");
  }
};

export const formatLocalizedTime = (time: string | Date) => {
  const currentLanguage = i18n.language;
  if (currentLanguage === "de") {
    return new Date(time).toLocaleTimeString("de-DE");
  } else {
    return new Date(time).toLocaleTimeString("en-US");
  }
};

export const formatXmlForApi = (xml: string | undefined) => {
  if (!xml) return "";
  return xml
    .replace(/[\n\r\t]/g, "")
    .replace(/\s{2,}/g, " ")
    .replace(/>\s+</g, "><")
    .trim();
};

export const formatJsonForApi = (json: string | undefined) => {
  if (!json) return "";
  try {
    const parsed = JSON.parse(json);
    return JSON.stringify(parsed);
  } catch (error) {
    console.error("Invalid JSON:", error);
    return json;
  }
};

export const formatJsonForEditor = (value: string) => {
  try {
    const parsed = JSON.parse(value);
    const formatted = JSON.stringify(parsed, null, 2);
    return { data: formatted, error: false };
  } catch (error) {
    return { data: "", error: true };
  }
};

export const formatXmlForEditor = (value: string) => {
  try {
    const formatted = format(value, {
      indentation: "  ",
    });
    return { data: formatted, error: false };
  } catch (error) {
    return { data: "", error: true };
  }
};

export const formatTemplate = (
  contentType: string | undefined,
  content: string | undefined
) => {
  if (!contentType || !content) return "";

  /* 
    ContentType could be 'json', 'xml', ContentType.JSON, ContentType.APPXML, ContentType.TEXTXML
    
    In app, select options set contentType to ContentType.JSON, ContentType.APPXML, ContentType.TEXTXML
    In AceEditor, contentType is set to 'json' or 'xml'

    This difference is due to the API returning ContentType enums, while AceEditor uses string identifiers for modes.
  */
  if (contentType === "json" || contentType === ContentType.JSON) {
    const result = formatJsonForEditor(content);
    if (result.error) {
      return "";
    } else {
      return result.data;
    }
  } else if (
    contentType === "xml" ||
    contentType === ContentType.APPXML ||
    contentType === ContentType.TEXTXML
  ) {
    const result = formatXmlForEditor(content);
    if (result.error) {
      return "";
    } else {
      return result.data;
    }
  }
};
